import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory('Notification');

export const pushNotification = actionCreator<INotificationProps>('PUSH');
export const consumeNotification = actionCreator('CONSUME');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/actions/notifications.ts